import PropTypes from 'prop-types'
import { VStack } from '@chakra-ui/react'
import {
  faCircleDollarToSlot,
  faIdCard,
  faWallet,
} from '@fortawesome/free-solid-svg-icons'
import React, { useMemo } from 'react'
import UnderlineHeading from '../../../components/UnderlineText/UnderlineHeading'
import Indicator, { indicatorTypes } from './Indicator'

export default function Indicators({ data }) {
  const name = useMemo(() => {
    const normalName = `${data?.sNombre} ${
      data?.sApellidoPaterno ? data?.sApellidoPaterno : ''
    }`
    if (data?.sTipoEmpleado === 'FI') {
      return `${data?.sEmpleado}`
    }
    return normalName
  }, [data])
  return (
    <VStack alignItems="flex-start" spacing="30px">
      <UnderlineHeading text="Indicadores" variant="h5" />
      <VStack w="100%" alignItems="flex-start">
        <Indicator
          type={indicatorTypes.currency}
          title="Saldo"
          value={data?.sSaldo}
          icon={faCircleDollarToSlot}
        />

        <Indicator
          title={'Número de bolsillo'}
          icon={faWallet}
          value={`*******${/\d{4}$/g.exec(data?.sTarjeta)}`}
        />
        <Indicator title={'Nombre de bolsillo'} value={name} icon={faIdCard} />
        {/* <Card height="200px" variant="indicator-chart" borderType="primary">
          <BarChart
            loading={loading}
            title={texts.frecuently_category}
            icon={faHandHoldingHeart}
            data={food}
            columns={categories}
          />
        </Card> */}
      </VStack>
    </VStack>
  )
}

Indicators.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
}
